import React from 'react';

export default function SharedButton({
  children,
  onClick,
  disabled,
  variant = 'primary',
  className = '',
  style = {}
}) {
  const btnClass = disabled
    ? `btn-gradient-${variant} shared-button disabled`
    : `btn-gradient-${variant} shared-button`;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${btnClass} ${className}`.trim()}
      style={style}
    >
      {children}
    </button>
  );
}
